const Style = {

  link: 'block text-primary-600 underline mb-4'

} 

export default Style;